import React, { useEffect, useState } from 'react';
import { useMutation } from '@apollo/client';
import AccountContentContainer from '../account/AccountContentContainer';
import Button from '../components/Button';
import Buttons from '../components/Buttons';
import { gql } from '../graphql/generated/gql';
import Link from '../utils/router/Link';

const MUTATION = gql(/** @complexity 2 */ `
  mutation DesktopLogin {
    token: createPasswordToken
  }
`);

const APP_DOWNLOAD_PAGE = 'https://go.slab.com/3vq5UD7';
const LOADING_WAIT_TIME = 3000;

const getAppLoginUrl = (token: string) => {
  const loginUrl = `${window.location.origin}/magic-link/${token}${window.location.search}`;
  return `slab://open-url/${encodeURIComponent(loginUrl)}`;
};

const AppLaunchView = () => {
  const [createToken] = useMutation(MUTATION);
  const [isLoading, setIsLoading] = useState(true);
  const [token, setToken] = useState<string>();

  useEffect(() => {
    if (!token) {
      return undefined;
    }

    window.location.href = getAppLoginUrl(token);
    const timeout = setTimeout(() => {
      setIsLoading(false);
    }, LOADING_WAIT_TIME);

    return () => clearTimeout(timeout);
  }, [token]);

  useEffect(() => {
    createToken().then(({ data }) => {
      setToken(data?.token);
    });
  }, [createToken]);

  return isLoading || !token ? (
    <AccountContentContainer
      title="Launching Slab…"
      subtitle="We're getting everything set up for you."
    />
  ) : (
    <AccountContentContainer
      title="Launch Slab"
      subtitle="Choose how you'd like to use Slab."
    >
      <Buttons>
        <Button block variant="primary" to={getAppLoginUrl(token)}>
          Open desktop app
        </Button>
        <Button block variant="secondary" to="/">
          Continue using browser version
        </Button>
      </Buttons>
      <hr />
      Still need the app?{' '}
      <Link to={APP_DOWNLOAD_PAGE} newTab>
        Download Slab
      </Link>
    </AccountContentContainer>
  );
};

export default AppLaunchView;
